import { CreateOrEditBuiltInPackageRepositoryTriggerPage } from "./CreateOrEditBuiltInPackageRepositoryTriggerPage";
interface BuiltInFeedTriggerPageProps {
    spaceId: string;
    projectSlug: string;
}
export function BuiltInFeedTriggerPage({ spaceId, projectSlug }: BuiltInFeedTriggerPageProps) {
    return <CreateOrEditBuiltInPackageRepositoryTriggerPage create={false} spaceId={spaceId} projectSlug={projectSlug}/>;
}
